/**
 * Google Maps 導航／定位連結（純座標 URL，不需 API key）
 */

/**
 * @param {number|string} lat
 * @param {number|string} lng
 * @returns {string|null}
 */
export function googleMapsDirUrl(lat, lng) {
  const la = Number(lat);
  const lo = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(lo)) return null;
  if (Math.abs(la) > 90 || Math.abs(lo) > 180) return null;
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${la},${lo}`)}`;
}

/**
 * 從 GeoJSON Feature／Leaflet LatLng／{lat,lng} 取座標。
 * @returns {{ lat: number, lng: number }|null}
 */
export function coordsFromGeo(input) {
  if (!input) return null;
  if (typeof input.lat === 'number' && typeof input.lng === 'number') {
    if (Number.isFinite(input.lat) && Number.isFinite(input.lng)) {
      return { lat: input.lat, lng: input.lng };
    }
  }
  if (typeof input.getLatLng === 'function') {
    try {
      const ll = input.getLatLng();
      if (ll && Number.isFinite(ll.lat) && Number.isFinite(ll.lng)) {
        return { lat: ll.lat, lng: ll.lng };
      }
    } catch {
      /* ignore */
    }
  }
  const c = input.geometry?.coordinates || input.coordinates;
  if (Array.isArray(c) && c.length >= 2) {
    const lng = Number(c[0]);
    const lat = Number(c[1]);
    if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
  }
  const p = input.properties || input;
  const lat = Number(p.lat ?? p.h_lat ?? p.Latitude);
  const lng = Number(p.lng ?? p.lon ?? p.h_lng ?? p.Longitude);
  if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
  return null;
}

/**
 * 彈窗用「Google 導航」按鈕 HTML（無座標則空字串）。
 * @param {number|string|{lat?:number,lng?:number}|object} latOrGeo
 * @param {number|string} [lng]
 * @param {{ label?: string }} [opts]
 */
export function googleMapsNavButtonHtml(latOrGeo, lng, opts = {}) {
  let lat = latOrGeo;
  let lon = lng;
  if (lon == null || typeof latOrGeo === 'object') {
    const c = coordsFromGeo(latOrGeo);
    if (!c) return '';
    lat = c.lat;
    lon = c.lng;
  }
  const url = googleMapsDirUrl(lat, lon);
  if (!url) return '';
  const label = String(opts.label || 'Google 導航');
  // 內聯樣式：各柜 Shadow／Leaflet popup 不必各自補 CSS
  return `<div class="gmaps-nav-wrap" style="margin:6px 0 8px">
  <a class="gmaps-nav-btn" href="${url}" target="_blank" rel="noopener noreferrer"
     style="display:inline-flex;align-items:center;gap:4px;padding:6px 10px;border-radius:6px;background:#1a73e8;color:#fff!important;font-size:12px;font-weight:600;text-decoration:none;line-height:1.2">
    <span aria-hidden="true">🗺️</span><span>${label}</span>
  </a>
</div>`;
}
